<template>
  <div class="flex flex-col min-h-0 flex-1">
    <div
      class="flex flex-col gap-4 overflow-y-auto custom-scroll px-4 pt-1 pb-3 flex-1"
    >
      <custom-field-list
        attribute-type="contact_attribute"
        attribute-class="conversation--attribute"
      />
    </div>
    <div
      class="flex items-center justify-center pt-4 shrink-0"
      style="box-shadow: rgb(239 239 239) 1px -2px 3px 0px"
    >
      <button
        class="flex items-center gap-1 h-8 px-3 border border-solid border-green-500 text-green-500 hover:bg-green-50 text-sm rounded-[5px] transition-colors"
        @click="openAddCustomFieldModal"
      >
        <span class="material-symbols-outlined text-[16px]">add</span>
        {{ $t('CUSTOM_ATTRIBUTES.ADD_BUTTON_TEXT') }}
      </button>
    </div>

    <custom-field-modal
      :show="showAddCustomFieldsModal"
      initial-attribute-type="contact_attribute"
      @close="showAddCustomFieldsModal = false"
      @add-field="addAttribute"
    />
  </div>
</template>

<script>
import CustomFieldList from './CustomFieldList.vue';
import CustomFieldModal from './CustomFieldModal.vue';
import customFieldMixins from './customFieldMixins';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  name: 'ContactTab',
  components: { CustomFieldList, CustomFieldModal },
  mixins: [customFieldMixins],
  computed: {
    attributeType() {
      return 'contact_attribute';
    },
    contactId() {
      return this.contact.id;
    },
  },
  methods: {
    async addAttribute({ attribute, attributeType }) {
      try {
        if (attributeType !== 'contact_attribute') return;

        const {
          attribute_key: attributeKey,
          attribute_display_type: attributeDisplayType,
          default_value: attributeDefaultValue,
        } = attribute;
        const isCheckbox = attributeDisplayType === 'checkbox';
        const defaultValue = isCheckbox ? false : attributeDefaultValue || null;

        await this.$store.dispatch('contacts/update', {
          id: this.contactId,
          custom_attributes: {
            ...this.customAttributes,
            [attributeKey]: defaultValue,
          },
        });

        bus.$emit(BUS_EVENTS.FOCUS_CUSTOM_ATTRIBUTE, attributeKey);
        this.showAlert(this.$t('CUSTOM_ATTRIBUTES.FORM.ADD.SUCCESS'));
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('CUSTOM_ATTRIBUTES.FORM.ADD.ERROR');
        this.showAlert(errorMessage);
      } finally {
        this.closeAddCustomFieldModal();
      }
    },
  },
};
</script>
